<template>
    <div class="management">
       <router-view></router-view>
    </div>
</template>

<script>
export default {
    name:'management',
    data(){
        return{
            
        }
    },
    methods:{
        
    }
}
</script>

<style>



</style>